import { makeAutoObservable } from "mobx";

interface ModalInterface {
  title?: string;
  description?: string;
  body?: JSX.Element;
  size?: "S" | "M";
  negativeButtonText: string;
  positiveButtonText: string;
  type?: "warning" | "confirm" | "success";
  hasUnsavedChanges?: boolean;
  showCheckbox?: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  onChangeCheckbox?: () => void;
}

const defaultModal: ModalInterface = {
  negativeButtonText: "",
  positiveButtonText: "",
  title: undefined,
  description: undefined,
  size: "S",
  hasUnsavedChanges: undefined,
  showCheckbox: undefined,
  isLoading: false,
  onConfirm: () => {},
  onClose: () => {},
  onChangeCheckbox: () => {},
};

export class ModalStore {
  constructor() {
    makeAutoObservable(this);
  }

  open: boolean = false;
  modal: ModalInterface = defaultModal;

  openConfirmModal({
    title,
    description,
    body,
    size,
    onConfirm,
    onClose,
    negativeButtonText,
    positiveButtonText,
    type,
    hasUnsavedChanges,
    showCheckbox,
    onChangeCheckbox,
    isLoading,
  }: ModalInterface): void {
    this.modal = {
      type: type ?? undefined,
      title,
      description,
      body,
      size,
      onConfirm,
      onClose,
      negativeButtonText,
      positiveButtonText,
      hasUnsavedChanges,
      showCheckbox,
      onChangeCheckbox,
      isLoading,
    };
    this.open = true;
  }

  closeConfirmModal(): void {
    this.open = false;
    this.modal = defaultModal;
  }
}
